import React from "react";
import { TextInput, Button, SaveButton, required, SimpleForm, useNotify, useRedirect, Toolbar, TopToolbar, usePermissions } from "react-admin";
import { Card, CardContent, Box } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useParams } from "react-router-dom";

const ResetPassword = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { id } = useParams(); 

  const {permissions} = usePermissions();
  if(permissions < 1){
    return;
  }

  const handlePasswordChange = async (data) => {
    const { newPassword, confirmPassword } = data;

    if (newPassword !== confirmPassword) {
      notify("新しいパスワードと確認用パスワードが一致しません。", { type: "error" });
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_DIR}/users/reset-password/${id}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        mode: 'cors',
        credentials: 'include',
        body: JSON.stringify({ newPassword }),
      });

      if (!response.ok) {
        throw new Error("パスワードリセットに失敗しました");
      }

      const result = await response.json();
      if (result.isError) {
        notify(result.message || "パスワードリセットに失敗しました", { type: "error" });
      } else {
        notify("パスワードのリセットが完了しました", { type: "success" });
        redirect(`/users/show/${id}`);
      }
    } catch (err) {
      notify("エラーが発生しました。", { type: "error" });
    }
  };

  const CustomTopToolbar = () => (
    <Box>
        <TopToolbar>
          <Button
            label="ユーザー表示"
            onClick={() => redirect(`/users/show/${id}`)}
            startIcon={<VisibilityIcon />}
          />
        </TopToolbar>
    </Box>
  );


  const CustomToolbar = () => (
    <Toolbar>
        <Box>
          <SaveButton label="パスワードをリセット" icon={<LockOpenIcon />} />
      </Box>
    </Toolbar>
  );

  return (
    <>
      <CustomTopToolbar/>
      <Card>
        <CardContent sx={{padding:0, marginBottom:-3}}>
          <SimpleForm
            onKeyDown={e => {
              if (e.key === 'Enter') {
                  e.preventDefault();
              }
            }}
            onSubmit={handlePasswordChange} toolbar={<CustomToolbar/>} 
          >
            <TextInput
              label="新しいパスワード"
              type="password"
              source="newPassword"
              fullWidth
              validate={required()}
            />
            <TextInput
              label="新しいパスワード（確認）"
              type="password"
              source="confirmPassword"
              fullWidth
              validate={required()}
            />
            
          </SimpleForm>
        </CardContent>
      </Card>
    </>
  );
};

export default ResetPassword;
